import { ActionType } from '../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, makeRsaaTypes } from '../../core/api/rsaa';
import { addError, addLoading, noLoadingNoError, getLoading } from '../../core/api/module';
import * as R from 'ramda';
import { Endpoints } from '../../core/api/endpoints';
import { AppState } from '../../core/redux/appState';
import { RaterApprovalParticipant } from '../models';


const KEY_ACTION = ActionType.RaterApprovalParticipantsRequest;
const ACTIONS    = [
  ActionType.RaterApprovalParticipantsRequest,
  ActionType.RaterApprovalParticipantsResponse,
  ActionType.RaterApprovalParticipantsError,
];


type Payload = RaterApprovalParticipant[];


type Meta = {
  personId: number;
};


/**
 * Dispatch this to retrieve all the participants whose raters the current user has been assigned to approve
 *
 * @param personId - the user's database Id
 */
export const raterApprovalParticipantsAction = (
  personId: number,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.RaterApprovalParticipants,
    headers:  { 'content-type': 'application/json' },
    body:     JSON.stringify({
      personId: personId,
    }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { personId }),
    bailout:  (state: AppState) => !!getLoading(state, KEY_ACTION, `${personId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const metaTag = `${action.meta.personId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  return R.assoc('raterApprovalParticipants', payload, successState);
};

export const raterApprovalParticipantsReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
